import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

/**
 * Three-tile stats roll-up for the Promotions page. Only renders when
 * there's at least one redemption (passing parents skip rendering when
 * `totals.uses === 0`).
 */
function StatTile({ label, value, danger }) {
  return (
    <Box sx={{ bgcolor: 'action.hover', p: '10px', borderRadius: '10px' }}>
      <Typography
        variant='caption'
        color='text.secondary'
        fontWeight='700'
        textTransform='uppercase'
        display='block'
      >
        {label}
      </Typography>
      <Typography
        variant='h6'
        fontWeight='800'
        sx={danger ? { color: 'error.main' } : undefined}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default function DiscountStats({ totals }) {
  return (
    <Grid container spacing='10px' mb='14px'>
      <Grid item xs={6} md={4}>
        <StatTile label='Redemptions' value={totals.uses} />
      </Grid>
      <Grid item xs={6} md={4}>
        <StatTile label='Revenue with coupon' value={totals.revenue.toFixed(2)} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StatTile label='Total discounted' value={`-${totals.discounted.toFixed(2)}`} danger />
      </Grid>
    </Grid>
  );
}
